import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import chartIcon from '../../../../assets/images/solutiondetails/whatwedeliver/ChartDonut.svg';
import swapIcon from '../../../../assets/images/solutiondetails/whatwedeliver/Swap.svg';
import presentationIcon from '../../../../assets/images/solutiondetails/whatwedeliver/PresentationChart.svg';
import compassIcon from '../../../../assets/images/solutiondetails/whatwedeliver/Compass.svg';
import './WhatWeDeliver.css';

const fallbackIcons = [chartIcon, swapIcon, presentationIcon, compassIcon];

const WhatWeDeliver = ({ title = 'What We Deliver', items }) => {
  if (!items?.length) {
    return null;
  }

  return (
    <section className="what-we-deliver">
      <div className="what-we-deliver__inner">
        <Reveal className="what-we-deliver__header">
          <h2 className="what-we-deliver__title">{title}</h2>
        </Reveal>

        <div className="what-we-deliver__grid">
          {items.map(({ title: itemTitle, text, icon }, index) => (
            <Reveal key={itemTitle} delay={index * 80}>
              <article className="what-we-deliver__card">
                <div className="what-we-deliver__icon">
                  <img src={icon || fallbackIcons[index]} alt="" aria-hidden="true" />
                </div>
                <h3 className="what-we-deliver__card-title">{itemTitle}</h3>
                <p className="what-we-deliver__card-text">{text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDeliver;
